import React from 'react';
import DefaultLayout from '../../../layouts/DefaultLayout';
import TemplateColumn from '../../../layouts/TemplateColumn';
import { PageHeader, PageIntro, AnchorLinks, PageSection, TriageList, PrimaryCallOut, FilterProvider } from '../../../components';
import GlobalSafetyData, { globalSafetyBlock } from './_global_safety_data'
import { jobCodes } from '../../../util/data/jobCodes';

// SEO INFORMATION
const pageMeta = {
    title: `Select Adverse Reactions for KEYTRUDA® (pembrolizumab) and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph)`,
    keywords: `adverse reactions, keytruda, pembrolizumab`,
    description: `Health care professionals may review incidence and management of selected immune-mediated adverse reactions to KEYTRUDA® (pembrolizumab) and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph).`,
    schemaJsonLD: [
        `{"@context":"https://schema.org/","url":"https://www.keytrudahcp.com/safety/adverse-reactions/","@type":"ApprovedIndication","name":"KEYTRUDA and KEYTRUDA QLEX™","alternateName":"pembrolizumab and berahyaluronidase alfa-pmph","description":"KEYTRUDA and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph) Injection 165 mg + 2,000 units/mL are monoclonal antibodies that belong to a class of drugs that bind to either the programmed death receptor-1 (PD⁠-⁠1) or the programmed death ligand 1 (PD⁠-⁠L1), blocking the PD⁠-⁠1/PD⁠-⁠L1 pathway, thereby removing inhibition of the immune response, potentially breaking peripheral tolerance and inducing immune-mediated adverse reactions."}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudahcp.com/safety/adverse-reactions/","@type":"MedicalAudience","audienceType":"Health Care Professionals","geographicArea":"This site is intended only for residents of the United States and its territories, including Puerto Rico."}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudahcp.com/safety/adverse-reactions/","@type":"MedicalWebPage","name":"Severe and Fatal Immune-Mediated Adverse Reactions","description":"Withhold or permanently discontinue KEYTRUDA and KEYTRUDA QLEX depending on severity of the immune-mediated adverse reaction. "}`
    ]
}

const jobCode = jobCodes[0].jobCode;

const anchorLinkModelData = [
    {label: 'Incidence of Selected Immune-Mediated Adverse Reactions'},
    {label: 'Management of Selected Immune-Mediated Adverse Reactions'},
    {label: 'Study-Specific Selected Adverse Reaction Data'}
]

const anchorLinkStudyData = [
    {label: 'NSCLC (KEYNOTE-671)'},
    {label: 'NSCLC (KEYNOTE-091)'},
    {label: 'TNBC (KEYNOTE-522)'},
    {label: 'Melanoma (KEYNOTE-716)'},
    {label: 'Melanoma (KEYNOTE-054)'},
    {label: 'NMIBC (KEYNOTE-057)'},
    {label: 'RCC (KEYNOTE-564)'}
]

const Page = ({ location }) => {

    return (
        <FilterProvider>
            <DefaultLayout jobCode={jobCode} pageMeta={ pageMeta } location={ location }>
                <div data-template-name="template-b">
                    {/* Begin Intro Column */}
                    <TemplateColumn id="template-b-intro" maxWidth={824}>
                        <PageHeader title="Selected Adverse Reactions" isBranding/>
                        <PageSection bgColor='cloud'  title="Severe and Fatal Immune-Mediated Adverse Reactions">
                            <PageIntro children={globalSafetyBlock} />
                            <AnchorLinks items={anchorLinkModelData} />
                        </PageSection>
                    </TemplateColumn>
                    {/* End Intro Column */}

                    {/* Begin Main Column */}
                    <TemplateColumn id="template-b-main">

                        <GlobalSafetyData />

                    <PageSection title={anchorLinkModelData[2].label}>
                        <TriageList listType='safety' />
                    </PageSection>
                    <PageSection bgColor="cloud">
                        <PrimaryCallOut
                            title="Not seeing the type of tumor you are looking for?"
                            content="For more information, including a complete list of indications KEYTRUDA is approved to treat, please see the full Prescribing Information for KEYTRUDA."
                            secondaryAction={{ label: 'View Prescribing Information', href: '/prescribing-information/', external: true, target: '_blank' }}
                        />
                    </PageSection>
                </TemplateColumn>
                {/* End Main Column */}
            </div>
        </DefaultLayout>
    </FilterProvider>
    );
};

export default Page;